import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_a16e29da from 'nuxt_plugin_plugin_a16e29da' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_templatesplugind8fe56d0_c43df03e from 'nuxt_plugin_templatesplugind8fe56d0_c43df03e' // Source: ./templates.plugin.d8fe56d0.js (mode: 'client')
import nuxt_plugin_nuxtleaflet_4a5e0d54 from 'nuxt_plugin_nuxtleaflet_4a5e0d54' // Source: ./nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_tooltipplugin20b62423_644303bc from 'nuxt_plugin_tooltipplugin20b62423_644303bc' // Source: ./tooltip.plugin.20b62423.js (mode: 'all')
import nuxt_plugin_buttonplugin361506c8_0fe77d26 from 'nuxt_plugin_buttonplugin361506c8_0fe77d26' // Source: ./button.plugin.361506c8.js (mode: 'all')
import nuxt_plugin_textareaplugin701aa164_0beff02e from 'nuxt_plugin_textareaplugin701aa164_0beff02e' // Source: ./textarea.plugin.701aa164.js (mode: 'all')
import nuxt_plugin_inputtextplugin6f231752_21dd272f from 'nuxt_plugin_inputtextplugin6f231752_21dd272f' // Source: ./inputtext.plugin.6f231752.js (mode: 'all')
import nuxt_plugin_multiselectplugin4c980b95_6e732609 from 'nuxt_plugin_multiselectplugin4c980b95_6e732609' // Source: ./multiselect.plugin.4c980b95.js (mode: 'all')
import nuxt_plugin_configplugin149b04ac_7d087374 from 'nuxt_plugin_configplugin149b04ac_7d087374' // Source: ./config.plugin.149b04ac.js (mode: 'all')
import nuxt_plugin_pluginutils_f63077ec from 'nuxt_plugin_pluginutils_f63077ec' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_bff11256 from 'nuxt_plugin_pluginrouting_bff11256' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6e37ecba from 'nuxt_plugin_pluginmain_6e37ecba' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_3f1c135e from 'nuxt_plugin_axios_3f1c135e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_templatesplugin02aad04a_6b5a42b4 from 'nuxt_plugin_templatesplugin02aad04a_6b5a42b4' // Source: ./templates.plugin.02aad04a.js (mode: 'client')
import nuxt_plugin_nuxtuseragent_5e4e6fda from 'nuxt_plugin_nuxtuseragent_5e4e6fda' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_whitelabel_9132a414 from 'nuxt_plugin_whitelabel_9132a414' // Source: ../plugins/whitelabel.js (mode: 'all')
import nuxt_plugin_vuegtag_44730e72 from 'nuxt_plugin_vuegtag_44730e72' // Source: ../plugins/vue-gtag.js (mode: 'all')
import nuxt_plugin_validation_7d99b1b0 from 'nuxt_plugin_validation_7d99b1b0' // Source: ../plugins/validation.js (mode: 'all')
import nuxt_plugin_debounce_06d08b0e from 'nuxt_plugin_debounce_06d08b0e' // Source: ../plugins/debounce.ts (mode: 'all')
import nuxt_plugin_sanitizer_b82b1ab8 from 'nuxt_plugin_sanitizer_b82b1ab8' // Source: ../plugins/sanitizer.js (mode: 'all')
import nuxt_plugin_ics_5e69c898 from 'nuxt_plugin_ics_5e69c898' // Source: ../plugins/ics.js (mode: 'all')
import nuxt_plugin_jsonld_2ff76817 from 'nuxt_plugin_jsonld_2ff76817' // Source: ../plugins/jsonld.ts (mode: 'all')
import nuxt_plugin_notifier_3e43155b from 'nuxt_plugin_notifier_3e43155b' // Source: ../plugins/notifier.js (mode: 'all')
import nuxt_plugin_clickOutside_0ea087a4 from 'nuxt_plugin_clickOutside_0ea087a4' // Source: ../plugins/clickOutside.js (mode: 'all')
import nuxt_plugin_tooltip_a5fff1ec from 'nuxt_plugin_tooltip_a5fff1ec' // Source: ../plugins/tooltip.js (mode: 'all')
import nuxt_plugin_vstripe_4841e0bd from 'nuxt_plugin_vstripe_4841e0bd' // Source: ../plugins/v-stripe.js (mode: 'client')
import nuxt_plugin_localStorage_830ec332 from 'nuxt_plugin_localStorage_830ec332' // Source: ../plugins/localStorage.ts (mode: 'client')
import nuxt_plugin_cropper_050a3380 from 'nuxt_plugin_cropper_050a3380' // Source: ../plugins/cropper.js (mode: 'client')
import nuxt_plugin_iframeResizercontentWindow_4c7bfeac from 'nuxt_plugin_iframeResizercontentWindow_4c7bfeac' // Source: ../node_modules/iframe-resizer/js/iframeResizer.contentWindow.js (mode: 'client')
import nuxt_plugin_nozoom_079c012e from 'nuxt_plugin_nozoom_079c012e' // Source: ../plugins/no-zoom.js (mode: 'client')
import nuxt_plugin_matomo_ad92b6a0 from 'nuxt_plugin_matomo_ad92b6a0' // Source: ../plugins/matomo.js (mode: 'client')
import nuxt_plugin_auth_9fbdb682 from 'nuxt_plugin_auth_9fbdb682' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../plugins/axios.ts (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"script":[{"hid":"seatsio","src":"https:\u002F\u002Fcdn.seatsio.net\u002Fchart.js"},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F","defer":true,"async":true}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ftickethead\u002Ffavicon.svg"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[{"cssText":".WEB_h72_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 400;\n}\n.WEB_h72_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 500;\n}\n.WEB_h72_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 600;\n}\n.WEB_h72_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 72px;\nline-height: 86.39999999999999px;\nletter-spacing: -1.44px;\nfont-weight: 700;\n}\n.WEB_h60_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 400;\n}\n.WEB_h60_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 500;\n}\n.WEB_h60_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 600;\n}\n.WEB_h60_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 60px;\nline-height: 66px;\nletter-spacing: -0.6px;\nfont-weight: 700;\n}\n.WEB_h48_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 400;\n}\n.WEB_h48_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 500;\n}\n.WEB_h48_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 600;\n}\n.WEB_h48_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 48px;\nline-height: 57.599999999999994px;\nletter-spacing: -0.96px;\nfont-weight: 700;\n}\n.WEB_h39_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 400;\n}\n.WEB_h39_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 500;\n}\n.WEB_h39_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 600;\n}\n.WEB_h39_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 39px;\nline-height: 42.900000000000006px;\nletter-spacing: -0.39px;\nfont-weight: 700;\n}\n.WEB_h36_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 400;\n}\n.WEB_h36_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 500;\n}\n.WEB_h36_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 600;\n}\n.WEB_h36_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 36px;\nline-height: 39.6px;\nletter-spacing: -0.36px;\nfont-weight: 700;\n}\n.WEB_h32_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 400;\n}\n.WEB_h32_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 500;\n}\n.WEB_h32_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 600;\n}\n.WEB_h32_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 32px;\nline-height: 35.2px;\nletter-spacing: 0px;\nfont-weight: 700;\n}\n.MOBILE_h24_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 400;\n}\n.MOBILE_h24_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 500;\n}\n.MOBILE_h24_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 600;\n}\n.MOBILE_h24_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 24px;\nline-height: 28.799999999999997px;\nletter-spacing: -0.24px;\nfont-weight: 700;\n}\n.MOBILE_h22_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 400;\n}\n.MOBILE_h22_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 500;\n}\n.MOBILE_h22_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 600;\n}\n.MOBILE_h22_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 22px;\nline-height: 24.200000000000003px;\nletter-spacing: -0.22px;\nfont-weight: 700;\n}\n.MOBILE_h20_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 400;\n}\n.MOBILE_h20_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 500;\n}\n.MOBILE_h20_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 600;\n}\n.MOBILE_h20_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 20px;\nline-height: 26px;\nletter-spacing: 0.2px;\nfont-weight: 700;\n}\n.MOBILE_h18_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 400;\n}\n.MOBILE_h18_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 500;\n}\n.MOBILE_h18_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 600;\n}\n.MOBILE_h18_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 18px;\nline-height: 21.599999999999998px;\nletter-spacing: 0px;\nfont-weight: 700;\n}\n.MOBILE_h16_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 400;\n}\n.MOBILE_h16_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 500;\n}\n.MOBILE_h16_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 600;\n}\n.MOBILE_h16_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 16px;\nline-height: 20.8px;\nletter-spacing: 0.16px;\nfont-weight: 700;\n}\n.MOBILE_h14_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 400;\n}\n.MOBILE_h14_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 500;\n}\n.MOBILE_h14_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 600;\n}\n.MOBILE_h14_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 14px;\nline-height: 18.2px;\nletter-spacing: 0.14px;\nfont-weight: 700;\n}\n.MOBILE_h13_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 400;\n}\n.MOBILE_h13_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 500;\n}\n.MOBILE_h13_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 600;\n}\n.MOBILE_h13_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 13px;\nline-height: 16.900000000000002px;\nletter-spacing: 0.13px;\nfont-weight: 700;\n}\n.MOBILE_h12_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 400;\n}\n.MOBILE_h12_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 500;\n}\n.MOBILE_h12_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 600;\n}\n.MOBILE_h12_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 12px;\nline-height: 15.600000000000001px;\nletter-spacing: 0.48px;\nfont-weight: 700;\n}\n.MOBILE_h11_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 400;\n}\n.MOBILE_h11_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 500;\n}\n.MOBILE_h11_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 600;\n}\n.MOBILE_h11_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 11px;\nline-height: 14.3px;\nletter-spacing: 0.44px;\nfont-weight: 700;\n}\n.MOBILE_h8_Regular{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 400;\n}\n.MOBILE_h8_Medium{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 500;\n}\n.MOBILE_h8_Semibold{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 600;\n}\n.MOBILE_h8_Bold{font-style: normal;\ncolor: #010E21;\nfont-size: 8px;\nline-height: 10.4px;\nletter-spacing: 0.32px;\nfont-weight: 700;\n}\n","type":"text\u002Fcss"}],"bodyAttrs":{"class":["p-input-filled"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_a16e29da === 'function') {
    await nuxt_plugin_plugin_a16e29da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugind8fe56d0_c43df03e === 'function') {
    await nuxt_plugin_templatesplugind8fe56d0_c43df03e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_4a5e0d54 === 'function') {
    await nuxt_plugin_nuxtleaflet_4a5e0d54(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltipplugin20b62423_644303bc === 'function') {
    await nuxt_plugin_tooltipplugin20b62423_644303bc(app.context, inject)
  }

  if (typeof nuxt_plugin_buttonplugin361506c8_0fe77d26 === 'function') {
    await nuxt_plugin_buttonplugin361506c8_0fe77d26(app.context, inject)
  }

  if (typeof nuxt_plugin_textareaplugin701aa164_0beff02e === 'function') {
    await nuxt_plugin_textareaplugin701aa164_0beff02e(app.context, inject)
  }

  if (typeof nuxt_plugin_inputtextplugin6f231752_21dd272f === 'function') {
    await nuxt_plugin_inputtextplugin6f231752_21dd272f(app.context, inject)
  }

  if (typeof nuxt_plugin_multiselectplugin4c980b95_6e732609 === 'function') {
    await nuxt_plugin_multiselectplugin4c980b95_6e732609(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin149b04ac_7d087374 === 'function') {
    await nuxt_plugin_configplugin149b04ac_7d087374(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_f63077ec === 'function') {
    await nuxt_plugin_pluginutils_f63077ec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_bff11256 === 'function') {
    await nuxt_plugin_pluginrouting_bff11256(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6e37ecba === 'function') {
    await nuxt_plugin_pluginmain_6e37ecba(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3f1c135e === 'function') {
    await nuxt_plugin_axios_3f1c135e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin02aad04a_6b5a42b4 === 'function') {
    await nuxt_plugin_templatesplugin02aad04a_6b5a42b4(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_5e4e6fda === 'function') {
    await nuxt_plugin_nuxtuseragent_5e4e6fda(app.context, inject)
  }

  if (typeof nuxt_plugin_whitelabel_9132a414 === 'function') {
    await nuxt_plugin_whitelabel_9132a414(app.context, inject)
  }

  if (typeof nuxt_plugin_vuegtag_44730e72 === 'function') {
    await nuxt_plugin_vuegtag_44730e72(app.context, inject)
  }

  if (typeof nuxt_plugin_validation_7d99b1b0 === 'function') {
    await nuxt_plugin_validation_7d99b1b0(app.context, inject)
  }

  if (typeof nuxt_plugin_debounce_06d08b0e === 'function') {
    await nuxt_plugin_debounce_06d08b0e(app.context, inject)
  }

  if (typeof nuxt_plugin_sanitizer_b82b1ab8 === 'function') {
    await nuxt_plugin_sanitizer_b82b1ab8(app.context, inject)
  }

  if (typeof nuxt_plugin_ics_5e69c898 === 'function') {
    await nuxt_plugin_ics_5e69c898(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff76817 === 'function') {
    await nuxt_plugin_jsonld_2ff76817(app.context, inject)
  }

  if (typeof nuxt_plugin_notifier_3e43155b === 'function') {
    await nuxt_plugin_notifier_3e43155b(app.context, inject)
  }

  if (typeof nuxt_plugin_clickOutside_0ea087a4 === 'function') {
    await nuxt_plugin_clickOutside_0ea087a4(app.context, inject)
  }

  if (typeof nuxt_plugin_tooltip_a5fff1ec === 'function') {
    await nuxt_plugin_tooltip_a5fff1ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vstripe_4841e0bd === 'function') {
    await nuxt_plugin_vstripe_4841e0bd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_830ec332 === 'function') {
    await nuxt_plugin_localStorage_830ec332(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cropper_050a3380 === 'function') {
    await nuxt_plugin_cropper_050a3380(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_iframeResizercontentWindow_4c7bfeac === 'function') {
    await nuxt_plugin_iframeResizercontentWindow_4c7bfeac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nozoom_079c012e === 'function') {
    await nuxt_plugin_nozoom_079c012e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_matomo_ad92b6a0 === 'function') {
    await nuxt_plugin_matomo_ad92b6a0(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_9fbdb682 === 'function') {
    await nuxt_plugin_auth_9fbdb682(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
